export default "__VITE_ASSET__DiMwuIMy__"